export default class {
    _id;
    _uid;
    _createdOn;
    _client;
    _area;
    _region;
    _account;
    _mailsCount;
    _packedMailsCount;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get uid() {
        return this._uid;
    }

    set uid(value) {
        this._uid = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get client() {
        return this._client;
    }

    set client(value) {
        this._client = value;
    }

    get area() {
        return this._area;
    }

    set area(value) {
        this._area = value;
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value;
    }

    get account() {
        return this._account;
    }

    set account(value) {
        this._account = value;
    }

    get mailsCount() {
        return this._mailsCount;
    }

    set mailsCount(value) {
        this._mailsCount = value;
    }

    get packedMailsCount() {
        return this._packedMailsCount;
    }

    set packedMailsCount(value) {
        this._packedMailsCount = value;
    }
}